<template>
    <div>
        <infinite-scroller-vertical @scrolledTillBottom="onReachScrollBottom">
            <v-row dense>
                <template v-for="(post) in items">
                    <v-col cols=6 :key="post.id">
                        <card-brief-post :title="post.title"
                        :photo="post.attachments.length ? post.attachments[0] : null"
                        :userDetails="post.user"
                        :link="`/post/${post.id}/`"></card-brief-post>
                    </v-col>
                </template>
            </v-row>
            <v-row dense v-if="searchLoading">
                <v-col v-for="(n,i) in 4" cols=6 :key="'post-loader' + i">
                    <v-skeleton-loader type="image" class="mt-5"></v-skeleton-loader>
                </v-col>
            </v-row>
        </infinite-scroller-vertical>
    </div>
</template>
<script>
import { CLEAR_SEARCH_LIST } from "@/store/mutations.type"
import cardBriefPost from "@/components/cards/card-brief-post.vue"
import searchTabMixin from "@/mixins/mixin-search-tab"
export default {
    mixins: [searchTabMixin],
    components: {
        cardBriefPost
    },

    data: () => ({}),

    created() {
        if (this.$route.query.key) {
            this.getSearchList()
        }
    },

    methods: {

        onReachScrollBottom(val) {
            if (val && this.$route.query.key) {
                this.getSearchList()
            }
        }
    },

    watch: {
        '$route.query.key'(val) {
            this.$store.commit(CLEAR_SEARCH_LIST)
            if (val) {
                this.getSearchList()
            }
        }
    }
}
</script>